import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LevelMasterService {
  constructor(private ws: PostmethodService) {}

  getLevelMaster(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'interesetLevelMaster'
    );
  }

  createLevelMaster(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'interesetLevelMaster'
    );
  }

  updateLevelMaster(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'interesetLevelMaster'
    );
  }
}
